import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, CircularProgress, Typography, Container } from "@mui/material";
import {
  getKpiReports,
  getKpiChartsData,
} from "../../business/redux/reducers/kpiReducer/actions";
import { KpiFilters } from "./KpiFilters";
import { KpiChartsSection } from "./KpiChartsSection";
import { KpiTablesSection } from "./KpiTablesSection";
import moment from "moment";

export const KpiPage = () => {
  const dispatch = useDispatch();
  const loading = useSelector((s) => s.loading);
  const kpiReducer = useSelector((s) => s.kpiReducer);
  const { kpiReportsData, kpiStatistics } = kpiReducer;

  const [filterParams, setFilterParams] = useState({
    owner_id: "",
    from: moment().subtract(7, "days").format("YYYY-MM-DD"),
    to: moment().format("YYYY-MM-DD"),
    attempt_count_from: "",
    attempt_count_to: "",
  });

  useEffect(() => {
    document.title = "KPI Leads Report";
    fetchKpiReports();
  }, []);

  const fetchKpiReports = (params = filterParams) => {
    const cleanParams = {};
    Object.keys(params).forEach((key) => {
      if (
        params[key] !== "" &&
        params[key] !== null &&
        params[key] !== undefined
      ) {
        cleanParams[key] = params[key];
      }
    });
    dispatch(getKpiReports(cleanParams));
    dispatch(getKpiChartsData(cleanParams));
  };

  const handleFilterChange = (newParams) => {
    setFilterParams(newParams);
    fetchKpiReports(newParams);
  };

  if (loading.isLoading && !kpiReportsData.length) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "400px",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ backgroundColor: "#F4F5F8", minHeight: "100vh", pb: 4 }}>
      <Container maxWidth="xl" sx={{ pt: 3 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 3,
          }}
        >
          <Typography
            variant="h4"
            fontWeight={700}
            fontSize="28px"
            color="#2B3033"
          >
            KPI Leads Report
          </Typography>
        </Box>

        <KpiFilters
          filterParams={filterParams}
          onFilterChange={handleFilterChange}
        />

        <KpiChartsSection statistics={kpiStatistics} loading={loading.isLoading} />

        <KpiTablesSection
          data={kpiReportsData}
          loading={loading.tableLoading}
        />
      </Container>
    </Box>
  );
};
